import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MobileOverlayCardComponent } from '@prlw/common/mobile-overlay-card/mobile-overlay-card.component';
import { EDisplayPriceTariffOption } from '@prlw/core/monitor/basis-best-price-mobile-price-options.service';
import { NumberFormatModule } from '@prlw/libs/number-format/number-format.module';

type TItem = {
  text: string;
  value: number | null;
  id: EDisplayPriceTariffOption;
  checked: boolean;
};

@Component({
  selector: 'prlw-basis-best-price-mobile-price-options-ui',
  standalone: true,
  imports: [CommonModule, MobileOverlayCardComponent, NumberFormatModule],
  templateUrl: './basis-best-price-mobile-price-options.component.html',
  styleUrl: './basis-best-price-mobile-price-options.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasisBestPriceMobilePriceOptionsComponent {
  @Input() items: TItem[] | null = null;

  @Output() eventClick = new EventEmitter<TItem['id']>();
  @Output() eventClose = new EventEmitter<void>();
}
